import React, { useEffect, useState } from "react";
import { DataStore, Predicates, SortDirection } from 'aws-amplify';
import { AppUser, DailyLog, Category } from '../../models';
import { StyleSheet, Text, ScrollView, TouchableOpacity, View, SafeAreaView, Image, Modal } from 'react-native';
import SwitchSelector from "react-native-switch-selector";
import DropDownPicker from 'react-native-dropdown-picker';
import { PieChart, Pie, Cell, Text as ChartText } from 'recharts';
import { formatToDate, formatDateAndWeek } from '../components/CmnUtil';
import IconImages from '../components/IconImages';
import * as CmnUtil from '../components/CmnUtil';

/** ================================
*  作業日誌レポート画面
*  ================================*/
const DiaryReport = ({ route, navigation }: { route: any, navigation: any; }) => {
  const [farmList, setFarmList] = useState(route.params["farm"]);
  const [selectFarm, setSelectFarm] = useState(farmList[0]);

  // 月/年切り替え[1: 月, 2: 年]
  const [reportType, setReportType] = useState("1");

  // 現在日付
  const [date, setDate] = useState(new Date());
  const [selectYear, setSelectYear] = useState(0);
  const [selectMonth, setSelectMonth] = useState(0);
  const [selectDate, setSelectDate] = useState(0);

  // 圃場選択ドロップダウン
  const [open, setOpen] = React.useState(false);
  const [pickerValue, setPickerValue] = React.useState("");
  const [pickerItems, setPickerItems] = React.useState([{ label: "選択してください", value: "default" }]);
  const [pickerZIndex, setPickerZIndex] = React.useState(1000);

  // 作業日誌データ
  const [totalWorkTime, setTotalWorkTime] = useState(0);

  // 作業日誌詳細モーダル表示State
  const [ismodal, setIsModal] = useState<boolean>(false);

  // 選択日誌
  const [selectDiary, setSelectDiary] = useState<any>();

  // 開花
  const [flowering, setFlowering] = useState(Array());
  const [floweringWorkTime, setFloweringWorkTime] = useState(0);
  const [floweringDisp, setFloweringDisp] = useState(false);

  // 農薬散布
  const [pesticideSprayning, setPesticideSprayning] = useState(Array());
  const [pesticideSprayningWorkTime, setPesticideSprayningWorkTime] = useState(0);
  const [pesticideSprayningDisp, setPesticideSprayningDisp] = useState(false);

  // 摘果作業
  const [fruitsThinning, setFruitsThinning] = useState(Array());
  const [fruitsThinningWorkTime, setFruitsThinningWorkTime] = useState(0);
  const [fruitsThinningDisp, setFruitsThinningDisp] = useState(false);

  // 交配
  const [mating, setMating] = useState(Array());
  const [matingWorkTime, setMatingWorkTime] = useState(0);
  const [matingDisp, setMatingDisp] = useState(false);

  // 収穫
  const [harvest, setHarvest] = useState(Array());
  const [harvestWorkTime, setHarvestWorkTime] = useState(0);
  const [harvestDisp, setHarvestDisp] = useState(false);

  // その他
  const [others, setOthers] = useState(Array());
  const [othersWorkTime, setOthersWorkTime] = useState(0);
  const [othersDisp, setOthersDisp] = useState(false);

  // 円グラフ
  const [graphData, setGraphData] = useState(Array());

  // グラフカラー
  const [graphColor, setGraphColor] = useState(Array());

  // グラフラベル
  const [graphLabel, setGraphLabel] = useState(Array());

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    fetchDiary();
  }, [selectMonth, selectYear, reportType, selectFarm]);

  /**
   * 初期化処理
   */
  const init = () => {
    // 日付設定
    setSelectYear(date.getFullYear());
    setSelectMonth(date.getMonth());
    setSelectDate(date.getDate());

    let farm_list = [{ label: "選択してください", value: "default" }];

    farmList.map((item: any, index: number) => {
      farm_list[index] = { label: item.name, value: item.name };
    });

    // 圃場リストの設定
    setPickerItems(farm_list);

    // 圃場選択リストの設定
    setPickerValue(farm_list[0]["value"]);
  };

  /**
   * 画面データのクリア
   */
  const crearDisp = () => {
    setGraphData(Array());
    setGraphColor(Array());
    setGraphLabel(Array());
    setFlowering(Array());
    setPesticideSprayning(Array());
    setFruitsThinning(Array());
    setMating(Array());
    setHarvest(Array());
    setOthers(Array());
    setTotalWorkTime(0);
    setFloweringWorkTime(0);
    setPesticideSprayningWorkTime(0);
    setFruitsThinningWorkTime(0);
    setMatingWorkTime(0);
    setHarvestWorkTime(0);
    setOthersWorkTime(0);
  };

  /**
   * 日誌データ取得
   */
  const fetchDiary = async () => {
    let floweringArray = new Array();
    let pesticideSprayningArray = new Array();
    let fruitsThinningArray = new Array();
    let matingArray = new Array();
    let harvestArray = new Array();
    let othersArray = new Array();
    let time1: number = 0;
    let time2: number = 0;
    let time3: number = 0;
    let time4: number = 0;
    let time5: number = 0;
    let time6: number = 0;

    // 日誌データ取得
    // 1: 月, 2: 年
    let diary_list_pre = new Array();
    if (reportType === '1') {
      let from_date = new Date(selectYear, selectMonth, selectDate);
      from_date.setDate(1);

      const set_from_date = from_date.getFullYear() + '-' +
        ('0' + (from_date.getMonth() + 1)).slice(-2) + '-0' + from_date.getDate();

      let to_date = new Date(selectYear, selectMonth, selectDate);
      to_date.setMonth(selectMonth + 1);
      to_date.setDate(0);

      const set_to_date = to_date.getFullYear() + '-' +
        ('0' + (to_date.getMonth() + 1)).slice(-2) + '-' + to_date.getDate();

      diary_list_pre = (await DataStore.query(DailyLog, Predicates.ALL, {
        sort: s => s.date(SortDirection.ASCENDING)
      })).filter(c => c.farm.id === selectFarm.id
        && set_from_date <= c.date
        && c.date <= set_to_date);
    } else {
      let current_month = new Date(selectYear, selectMonth, selectDate);
      const set_current_month = current_month.getFullYear().toString();

      diary_list_pre = (await DataStore.query(DailyLog, Predicates.ALL, {
        sort: s => s.date(SortDirection.ASCENDING)
      })).filter(c => c.farm.id === selectFarm.id
        && c.date.match(set_current_month));
    }

    const diary_list = await Promise.all(diary_list_pre.map(async (diary) => {
      const user = await DataStore.query(AppUser, diary.authorID);
      return { ...diary, "authorName": user?.username };
    }));

    diary_list.map((diary) => {
      switch (diary.category) {
        case Category.FLOWERING:
          floweringArray.push(diary);
          time1 += diary.workingTime ? diary.workingTime : 0;
          break;
        case Category.PESTICIDE_SPRAYNING:
          pesticideSprayningArray.push(diary);
          time2 += diary.workingTime ? diary.workingTime : 0;
          break;
        case Category.FRUITS_THINNING:
          fruitsThinningArray.push(diary);
          time3 += diary.workingTime ? diary.workingTime : 0;
          break;
        case Category.MATING:
          matingArray.push(diary);
          time4 += diary.workingTime ? diary.workingTime : 0;
          break;
        case Category.HARVEST:
          harvestArray.push(diary);
          time5 += diary.workingTime ? diary.workingTime : 0;
          break;
        case Category.OTHERS:
          othersArray.push(diary);
          time6 += diary.workingTime ? diary.workingTime : 0;
          break;
        default:
          break;
      }
    });

    let chart_array = new Array();
    let color_array = new Array();
    let label_array = new Array();
    if (floweringArray.length !== 0) {
      chart_array.push({ name: '開花', value: time1 });
      color_array.push('#f08080');
      label_array.push({ name: '開花', value: Category.FLOWERING });
      setFlowering(floweringArray);
    }
    if (pesticideSprayningArray.length !== 0) {
      chart_array.push({ name: '農薬散布', value: time2 });
      color_array.push('#F5D1B3');
      label_array.push({ name: '農薬散布', value: Category.PESTICIDE_SPRAYNING });
      setPesticideSprayning(pesticideSprayningArray);
    }
    if (fruitsThinningArray.length !== 0) {
      chart_array.push({ name: '摘果作業', value: time3 });
      color_array.push('#C2DBEB');
      label_array.push({ name: '摘果作業', value: Category.FRUITS_THINNING });
      setFruitsThinning(fruitsThinningArray);
    }
    if (matingArray.length !== 0) {
      chart_array.push({ name: '交配', value: time4 });
      color_array.push('#ffd700');
      label_array.push({ name: '交配', value: Category.MATING });
      setMating(matingArray);
    }
    if (harvestArray.length !== 0) {
      chart_array.push({ name: '収穫', value: time5 });
      color_array.push('#bb6edb');
      label_array.push({ name: '収穫', value: Category.HARVEST });
      setHarvest(harvestArray);
    }
    if (othersArray.length !== 0) {
      chart_array.push({ name: 'その他', value: time6 });
      color_array.push('#DBDBDB');
      label_array.push({ name: 'その他', value: Category.OTHERS });
      setOthers(othersArray);
    }

    setGraphData(chart_array);
    setGraphColor(color_array);
    setGraphLabel(label_array);

    const sum_time = time1 + time2 + time3 + time4 + time5 + time6;
    setFloweringWorkTime(time1);
    setPesticideSprayningWorkTime(time2);
    setFruitsThinningWorkTime(time3);
    setMatingWorkTime(time4);
    setHarvestWorkTime(time5);
    setOthersWorkTime(time6);
    setTotalWorkTime(sum_time);
  };

  /**
   * 画面切り替え 
   */
  const onswitch = (setType: string) => {
    setReportType(setType);
    crearDisp();
  };

  /** 
   * 圃場切り替え 
   */
  const changeFarm = () => {
    if (pickerValue) {
      let result = farmList.filter(function (value: any) {
        // 現在選択している圃場に一致するデータをセット
        return value.name === pickerValue;
      });
      setSelectFarm(result[0]);
      crearDisp();
    }
  };

  /** 
   * 前月のカレンダーへ 
   */
  const prevMonth = () => {
    if (selectMonth == 0) {
      setSelectMonth(11);
      setSelectYear(selectYear - 1);
    } else {
      setSelectMonth(selectMonth - 1);
    }
    crearDisp();
  };

  /** 
   * 次月のカレンダーへ 
   */
  const nextMonth = () => {
    if (selectMonth == 11) {
      setSelectMonth(0);
      setSelectYear(selectYear + 1);
    } else {
      setSelectMonth(selectMonth + 1);
    }
    crearDisp();
  };


  /** 
   * 前月のカレンダーへ 
   */
  const prevYear = () => {
    setSelectYear(selectYear - 1);
    crearDisp();
  };

  /** 
   * 次月のカレンダーへ 
   */
  const nextYear = () => {
    setSelectYear(selectYear + 1);
    crearDisp();
  };

  /**
   * 作業時間(時間)を返す
   */
  const convertHour = (time: number) => {
    // 作業時間を時間と分にわける
    let hour = Math.floor(time / 60);
    return hour.toString();
  };

  /**
   * 作業時間(分)を返す
   */
  const convertMinute = (time: number) => {
    // 作業時間を時間と分にわける
    let min = time % 60;
    return min.toString();
  };


  /** 
   * ラベル表示レイアウト
   */
  const getLabelStyle = (category: Category) => {
    switch (category) {
      case Category.FLOWERING:
        return { color: "#f08080" };
      case Category.PESTICIDE_SPRAYNING:
        return { color: "#F5D1B3" };
      case Category.FRUITS_THINNING:
        return { color: "#C2DBEB" };
      case Category.MATING:
        return { color: "#ffd700" };
      case Category.HARVEST:
        return { color: "#bb6edb" };
      case Category.OTHERS:
        return { color: "#DBDBDB" };
      default:
        return { color: "#DBDBDB" };
    }
  };

  /** 
   * 作業日誌詳細モーダル表示
   */
  const dispDiayDetail = (diary: DailyLog) => {
    setSelectDiary(diary);
    setIsModal(!ismodal);
  };

  /** 
   * カテゴリー表示レイアウト
   */
  const getCategoryStyle = (category: Category) => {
    switch (category) {
      case Category.FLOWERING:
        return WorkTimeViewStyles.floweringWorkTime;
      case Category.PESTICIDE_SPRAYNING:
        return WorkTimeViewStyles.pesticideSprayningWorkTime;
      case Category.FRUITS_THINNING:
        return WorkTimeViewStyles.fruitsThinningWorkTime;
      case Category.MATING:
        return WorkTimeViewStyles.matingWorkTime;
      case Category.HARVEST:
        return WorkTimeViewStyles.harvestWorkTime;
      case Category.OTHERS:
        return WorkTimeViewStyles.othersWorkTime;
      default:
        return WorkTimeViewStyles.othersWorkTime;
    }
  };

  /** 
   * カテゴリー表示レイアウト
   */
  const getDispIconStyle = (category: Category) => {
    switch (category) {
      case Category.FLOWERING:
        return WorkTimeDispIconStyle.floweringDispIcon;
      case Category.PESTICIDE_SPRAYNING:
        return WorkTimeDispIconStyle.pesticideSprayningDispIcon;
      case Category.FRUITS_THINNING:
        return WorkTimeDispIconStyle.fruitsThinningDispIcon;
      case Category.MATING:
        return WorkTimeDispIconStyle.matingDispIcon;
      case Category.HARVEST:
        return WorkTimeDispIconStyle.harvestDispIcon;
      case Category.OTHERS:
        return WorkTimeDispIconStyle.othersDispIcon;
      default:
        return WorkTimeDispIconStyle.othersDispIcon;
    }
  };

  /** 
   * カテゴリー表示レイアウト
   */
  const getItemViewStyle = (category: Category) => {
    switch (category) {
      case Category.FLOWERING:
        return WorkTimeDispStyles.floweringDisp;
      case Category.PESTICIDE_SPRAYNING:
        return WorkTimeDispStyles.pesticideSprayningDisp;
      case Category.FRUITS_THINNING:
        return WorkTimeDispStyles.fruitsThinningDisp;
      case Category.MATING:
        return WorkTimeDispStyles.matingDisp;
      case Category.HARVEST:
        return WorkTimeDispStyles.harvestDisp;
      case Category.OTHERS:
        return WorkTimeDispStyles.othersDisp;
      default:
        return WorkTimeDispStyles.othersDisp;
    }
  };

  /** 
   * カテゴリー表示レイアウト
   */
  const getDiaryItemStyle = (category: Category) => {
    switch (category) {
      case Category.FLOWERING:
        return WorkTimeDiaryItemStyle.floweringDiaryItem;
      case Category.PESTICIDE_SPRAYNING:
        return WorkTimeDiaryItemStyle.pesticideSprayningDiaryItem;
      case Category.FRUITS_THINNING:
        return WorkTimeDiaryItemStyle.fruitsThinningDiaryItem;
      case Category.MATING:
        return WorkTimeDiaryItemStyle.matingDiaryItem;
      case Category.HARVEST:
        return WorkTimeDiaryItemStyle.harvestDiaryItem;
      case Category.OTHERS:
        return WorkTimeDiaryItemStyle.othersDiaryItem;
      default:
        return WorkTimeDiaryItemStyle.othersDiaryItem;
    }
  };


  /**
   * 作業日誌詳細開閉
   */
  const setDispFlg = (category: Category) => {
    switch (category) {
      case Category.FLOWERING:
        setFloweringDisp(!floweringDisp);
        break;
      case Category.PESTICIDE_SPRAYNING:
        setPesticideSprayningDisp(!pesticideSprayningDisp);
        break;
      case Category.FRUITS_THINNING:
        setFruitsThinningDisp(!fruitsThinningDisp);
        break;
      case Category.MATING:
        setMatingDisp(!matingDisp);
        break;
      case Category.HARVEST:
        setHarvestDisp(!harvestDisp);
        break;
      case Category.OTHERS:
        setOthersDisp(!othersDisp);
        break;
      default:
        break;
    }
    return;
  };


  /**
   * 画面共通レイアウト
   */
  const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: "#E2F0D9",
    },
  });

  /**
   * 作業日誌遷移レイアウト
   */
  const diaryLinkStyles = StyleSheet.create({
    diaryLinkView: {
      width: "50%",
      marginTop: 0,
      marginLeft: 0,
    },
    diaryLinkText: {
      fontSize: 20,
    },
  });

  /**
   * 圃場選択リストレイアウト
   */
  const dropDownStyles = StyleSheet.create({
    dropDownPicker: {
      width: "50%",
      marginLeft: "auto",
      marginRight: 0,
      marginBottom: 5,
      zIndex: pickerZIndex
    },
    dropDownPickerItems: {
      backgroundColor: "#ffffff",
      flexDirection: 'row',
      borderWidth: 2,
      BorderStyle: "solid",
      borderColor: "#78ac44",
    },
    dropDownPickerLabel: {
      textAlign: 'center',
    },
    dropDownPickerSelectedLabel: {
      color: '#78ac44',
    },
    dropDownContainer: {
      borderWidth: 2,
      BorderStyle: "solid",
      borderColor: "#78ac44",
    },
    dropDownText: {
      fontSize: 18,
    },
  });

  /**
   * 年月切り替えレイアウト
   */
  const switchSelectorStyles = StyleSheet.create({
    selectorView: {
      flexDirection: "row",
      alignItems: 'center',
      justifyContent: 'center',
    },
    selector: {
      width: "50%",
    },
  });

  /** 
   * 月選択ナビゲーションレイアウト 
   */
  const monthSelectStyles = StyleSheet.create({
    monthSelectView: {
      flexDirection: "row",
      alignItems: 'center',
      justifyContent: 'center',
    },
    selectButton: {
      fontSize: 24,
    },
    selectText: {
      fontSize: 24,
      marginHorizontal: 10,
      width: 150,
      textAlign: "center",
      fontWeight: "bold"
    }
  });

  /**
   * 作業時間表示レイアウト
   */
  const workTimeStyles = StyleSheet.create({
    scrollView: {
      flex: 1,
    },
    totalWorkTimeView: {
      alignItems: 'center',
      justifyContent: 'space-between',
      fontWeight: "bold",
      backgroundColor: "#A6CD8D",
      flexDirection: "row",
      marginBottom: 3,
    },
    totalWorkTimeText: {
      width: "50%",
      padding: 3,
      fontSize: 18,
    },
    categoryView: {
      marginTop: 10,
      zIndex: 500,
    },
    categoryWorkPartView: {
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: "row",
    },
    categoryWorkPartLabel: {
      fontWeight: "bold",
    },
    categoryWorkPartText: {
      width: "50%",
      padding: 3,
      fontSize: 18,
    },
    iconView: {
      position: "absolute",
      right: 5,
    },
  });

  /** 
   * 円グラフレイアウト
   */
  const chartStyles = StyleSheet.create({
    chartView: {
      flexDirection: "row",
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 20,
      height: 250,
      zIndex: -100
    },
    chartLabelView: {
      flexDirection: "row",
      alignItems: 'center',
      justifyContent: 'center',
      height: 50,
    },
  });

  /**
   * ダイアログレイアウト
   */
  const dialogStyles = StyleSheet.create({
    dialogContainer: {
      position: "absolute",
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "rgba(150,150,150,0.6)",
    },
    dialogIcon: {
      width: 30,
      height: 30,
      position: "absolute",
      right: 0,
    },
    categoryArea: {
      alignItems: "center",
      marginTop: 30,
    },
    categoryText: {
      fontSize: 24,
    },
    dialogBox: {
      width: "100%",
      height: 580,
      backgroundColor: "#FDF1E9",
      borderBottomColor: "#2C6393",
      borderBottomWidth: 2,
      borderTopColor: "#2C6393",
      borderTopWidth: 2,
      borderStyle: "solid"
    },
    dialogText: {
      fontSize: 18,
      width: "100%",
      backgroundColor: "#ffffff",
      textAlign: "center",
      borderBottomColor: "#EB6E19",
      borderBottomWidth: 2,
      borderTopColor: "#EB6E19",
      borderTopWidth: 2,
      borderStyle: "solid",
      marginBottom: 20,
    },
    dialogBottomBox: {
      // flex: 0.2,
      // flexDirection: "row",
      // justifyContent: "space-between",
    },
    memoArea: {
      fontSize: 18,
      width: "100%",
      height: 200,
      backgroundColor: "#ffffff",
      textAlign: "center",
      borderBottomColor: "#EB6E19",
      borderBottomWidth: 2,
      borderTopColor: "#EB6E19",
      borderTopWidth: 2,
      borderStyle: "solid",
      marginBottom: 20,
    }
  });

  /**
   * カテゴリー別作業時間合計表示非表示
   */
  const WorkTimeDispStyles = StyleSheet.create({
    floweringDisp: { display: floweringDisp ? "flex" : "none" },
    pesticideSprayningDisp: { display: pesticideSprayningDisp ? "flex" : "none" },
    fruitsThinningDisp: { display: fruitsThinningDisp ? "flex" : "none" },
    matingDisp: { display: matingDisp ? "flex" : "none" },
    harvestDisp: { display: harvestDisp ? "flex" : "none" },
    othersDisp: { display: othersDisp ? "flex" : "none" },
  });

  /**
   * カテゴリー別作業時間合計View
   */
  const WorkTimeViewStyles = StyleSheet.create({
    floweringWorkTime: { backgroundColor: "#f08080" },
    pesticideSprayningWorkTime: { backgroundColor: "#F5D1B3", },
    fruitsThinningWorkTime: { backgroundColor: "#C2DBEB", },
    matingWorkTime: { backgroundColor: "#ffd700", },
    harvestWorkTime: { backgroundColor: "#bb6edb", },
    othersWorkTime: { backgroundColor: "#DBDBDB", },
  });

  /**
   * カテゴリー別作業時間合計　開閉アイコン
   */
  const WorkTimeDispIconStyle = StyleSheet.create({
    floweringDispIcon: { transform: [{ scaleX: floweringDisp ? -1 : 1 }, { scaleY: floweringDisp ? -1 : 1 }] },
    pesticideSprayningDispIcon: { transform: [{ scaleX: pesticideSprayningDisp ? -1 : 1 }, { scaleY: pesticideSprayningDisp ? -1 : 1 }] },
    fruitsThinningDispIcon: { transform: [{ scaleX: fruitsThinningDisp ? -1 : 1 }, { scaleY: fruitsThinningDisp ? -1 : 1 }] },
    matingDispIcon: { transform: [{ scaleX: matingDisp ? -1 : 1 }, { scaleY: matingDisp ? -1 : 1 }] },
    harvestDispIcon: { transform: [{ scaleX: harvestDisp ? -1 : 1 }, { scaleY: harvestDisp ? -1 : 1 }] },
    othersDispIcon: { transform: [{ scaleX: othersDisp ? -1 : 1 }, { scaleY: othersDisp ? -1 : 1 }] },
  });

  /**
   * 作業時間詳細
   */
  const WorkTimeDiaryItemStyle = StyleSheet.create({
    floweringDiaryItem: { backgroundColor: "#f08080" },
    pesticideSprayningDiaryItem: { backgroundColor: "#F5D1B3" },
    fruitsThinningDiaryItem: { backgroundColor: "#C8DFE8" },
    matingDiaryItem: { backgroundColor: "#ffd700" },
    harvestDiaryItem: { backgroundColor: "#bb6edb" },
    othersDiaryItem: { backgroundColor: "#DBDBDB" },
  });

  /**
   * 作業時間詳細アイコン
   */
  const WorkTimeIconStyles = StyleSheet.create({
    infoIcon: {
      width: 20,
      height: 20,
    },
  });

  /**
   * 作業日誌詳細ダイアログ表示
   */
  const DiaryDetail = () => {
    if (selectDiary) {
      let calcTime = Number(selectDiary?.workingTime);
      let hour = Math.floor(calcTime / 60);
      let min = calcTime % 60;
      const tmpVarieties = [];
      if (selectDiary.varieties) {
        for (const variety of selectDiary.varieties) {
          if (variety) {
            tmpVarieties.push(CmnUtil.varietiesCnv(variety));
          }
        }
      }

      return (
        <Modal
          transparent={true}
          visible={ismodal}
          onRequestClose={() => {
            setIsModal(!ismodal);
          }}
        >
          <View style={dialogStyles.dialogContainer}>
            <View style={dialogStyles.dialogBox}>
              <TouchableOpacity onPress={() => setIsModal(!ismodal)} >
                <Image style={dialogStyles.dialogIcon} source={IconImages.icCloseBlack} />
              </TouchableOpacity>

              <View style={dialogStyles.categoryArea}>
                <Text style={dialogStyles.categoryText}>{CmnUtil.getCategoryName(selectDiary?.category)}</Text>
              </View>
              <View>
                <Text style={dialogStyles.dialogText}>{selectDiary?.farm.name}</Text>
                <Text style={dialogStyles.dialogText}>{formatDateAndWeek(formatToDate(selectDiary?.date))}</Text>
                <Text style={dialogStyles.dialogText}>{hour}時間 {min} 分</Text>
                {tmpVarieties.length > 0 && <Text style={dialogStyles.dialogText}>{tmpVarieties.join("・")}</Text>}
                <Text style={dialogStyles.dialogText}>{selectDiary?.authorName}</Text>
              </View>
              <View>
                <Text>メモ</Text>
                <View>
                  <Text style={dialogStyles.memoArea}>{selectDiary?.workMemo}</Text>
                </View>
              </View>
            </View>
          </View>
        </Modal>
      );
    } else {
      return (
        <View></View>
      );
    }
  };

  /**
   * カテゴリ毎作業時間表示View
   */
  const WorkTimeCell = ({ category, diaryData, workTime }: { category: Category, diaryData: any, workTime: number; }) => {

    return (
      <View>
        <TouchableOpacity onPress={() => setDispFlg(category)} style={[workTimeStyles.categoryWorkPartView, getCategoryStyle(category)]}>
          <Text style={[workTimeStyles.categoryWorkPartLabel, workTimeStyles.categoryWorkPartText]}>{CmnUtil.getCategoryName(category)}</Text>
          <Text style={[workTimeStyles.categoryWorkPartText]}>{convertHour(workTime) + '時間' + convertMinute(workTime) + '分'}</Text>
          <TouchableOpacity style={[workTimeStyles.iconView]} onPress={() => setDispFlg(category)}>
            <Image style={[WorkTimeIconStyles.infoIcon, getDispIconStyle(category)]} source={IconImages.icDownArrowBlack} />
          </TouchableOpacity>
        </TouchableOpacity>
        <View style={[getItemViewStyle(category)]}>
          {
            diaryData.map((item: any, index: number) => {
              return (
                <TouchableOpacity
                  onPress={() => dispDiayDetail(item)}
                  style={[workTimeStyles.categoryWorkPartView, getDiaryItemStyle(category)]}
                  key={index}>
                  <Text style={[workTimeStyles.categoryWorkPartText]}>{formatDateAndWeek(formatToDate(item.date))}</Text>
                  <Text style={[workTimeStyles.categoryWorkPartText]}>{convertHour(item.workingTime) + '時間' + convertMinute(item.workingTime) + '分'}</Text>
                  <TouchableOpacity style={[workTimeStyles.iconView]} onPress={() => dispDiayDetail(item)}>
                    <Image style={[WorkTimeIconStyles.infoIcon]} source={IconImages.icInfoBlack} />
                  </TouchableOpacity>
                </TouchableOpacity>
              );
            })
          }
        </View>
      </View>
    );
  };

  /**
   * 作業時間別円グラフ
   */
  const WorkTimeCharts = () => {
    const label = ({ name, value, cx, cy, innerRadius, outerRadius, midAngle }:
      { name: string, value: number, cx: number, cy: number, x: number, y: number, innerRadius: number, outerRadius: number, midAngle: number; }) => {
      const radian = Math.PI / 180;
      const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
      const x = cx + radius * Math.cos(-midAngle * radian);
      const y = cy + radius * Math.sin(-midAngle * radian);
      const textAnchor = x > cx ? "start" : "end";
      const label_value = Math.floor((value / 60) * 100) / 100;
      return (
        <>
          <ChartText x={x} y={y} textAnchor={textAnchor} dominantBaseline="hanging" fill="#000000">{label_value}</ChartText>
        </>
      );
    };

    return (
      <View>
        <View style={chartStyles.chartView}>
          <PieChart width={400} height={400}>
            <Pie
              data={graphData}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={label}
              outerRadius={100}
              fill="#8884d8"
              dataKey="value"
              isAnimationActive={false}
            >
              {
                graphData.map((entry, index) => (
                  <Cell key={index} fill={graphColor[index % graphColor.length]} />
                ))
              }
            </Pie>
          </PieChart>
        </View>
        <View style={chartStyles.chartLabelView}>
          {
            graphLabel.map((entry, index) => {
              return (
                <Text key={index}>
                  <Text style={getLabelStyle(entry.value)}>■</Text>{entry.name}</Text>
              );
            })
          }
        </View>
      </View>
    );
  };

  return (
    <SafeAreaView style={styles.container}>
      {/* 作業日誌遷移 */}
      <View style={diaryLinkStyles.diaryLinkView}>
        <TouchableOpacity onPress={() => navigation.goBack()}>
          <Text style={diaryLinkStyles.diaryLinkText}>&lt; 作業日誌へ</Text>
        </TouchableOpacity>
      </View>

      {/* 圃場切り替え */}
      <View style={dropDownStyles.dropDownPicker}>
        <DropDownPicker
          open={open}
          value={pickerValue}
          items={pickerItems}
          setOpen={setOpen}
          setValue={setPickerValue}
          setItems={setPickerItems}
          onChangeValue={changeFarm}
          showTickIcon={false}
          placeholder={pickerValue}
          style={dropDownStyles.dropDownPickerItems}
          textStyle={dropDownStyles.dropDownText}
          dropDownContainerStyle={dropDownStyles.dropDownContainer}
          labelStyle={dropDownStyles.dropDownPickerLabel}
          selectedItemLabelStyle={dropDownStyles.dropDownPickerSelectedLabel}
          onOpen={() => { setPickerZIndex(1000); }}
          onClose={() => { setPickerZIndex(0); }}
        />
      </View>

      {/* 年月切り替え */}
      <View style={switchSelectorStyles.selectorView}>
        <SwitchSelector
          initial={0}
          onPress={onswitch}
          textColor="#ffffff"
          selectedColor="#ffffff"
          buttonColor="#7AAD47"
          borderColor="#057E32"
          backgroundColor="#808080"
          borderRadius={0}
          style={{ width: "50%", zIndex: 100 }}
          hasPadding
          options={[
            {
              label: "月",
              value: "1",
            },
            {
              label: "年",
              value: "2"
            },
          ]}
        />
      </View>
      {
        reportType == "1" ?
          <View>
            {/* 月選択ナビゲーション */}
            <View style={monthSelectStyles.monthSelectView}>
              <TouchableOpacity onPress={prevMonth}>
                <Text style={monthSelectStyles.selectButton}>&lt;</Text>
              </TouchableOpacity>
              <Text style={monthSelectStyles.selectText}>{selectYear}年{selectMonth + 1}月</Text>
              <TouchableOpacity onPress={nextMonth}>
                <Text style={monthSelectStyles.selectButton}>&gt;</Text>
              </TouchableOpacity>
            </View>
          </View>
          :
          <View>
            {/* 年選択ナビゲーション */}
            <View style={monthSelectStyles.monthSelectView}>
              <TouchableOpacity onPress={prevYear}>
                <Text style={monthSelectStyles.selectButton}>&lt;</Text>
              </TouchableOpacity>
              <Text style={monthSelectStyles.selectText}>{selectYear}年</Text>
              <TouchableOpacity onPress={nextYear}>
                <Text style={monthSelectStyles.selectButton}>&gt;</Text>
              </TouchableOpacity>
            </View>
          </View>
      }
      <ScrollView
        style={workTimeStyles.scrollView}
        showsVerticalScrollIndicator={false}>
        {/* 総作業時間表示 */}
        <View style={workTimeStyles.totalWorkTimeView}>
          <Text style={[workTimeStyles.totalWorkTimeText, workTimeStyles.categoryWorkPartLabel]}>総作業時間</Text>
          <Text style={[workTimeStyles.totalWorkTimeText]}>{convertHour(totalWorkTime) + '時間' + convertMinute(totalWorkTime) + '分'}</Text>
        </View>

        {/* カテゴリ毎作業時間表示 */}
        <View style={[workTimeStyles.categoryView]}>
          {
            function () {
              if (flowering.length !== 0) {
                return (
                  <WorkTimeCell category={Category.FLOWERING} diaryData={flowering} workTime={floweringWorkTime} />
                );
              }
            }()
          }
          {
            function () {
              if (pesticideSprayning.length !== 0) {
                return (
                  <WorkTimeCell category={Category.PESTICIDE_SPRAYNING} diaryData={pesticideSprayning} workTime={pesticideSprayningWorkTime} />
                );
              }
            }()
          }
          {
            function () {
              if (fruitsThinning.length !== 0) {
                return (
                  <WorkTimeCell category={Category.FRUITS_THINNING} diaryData={fruitsThinning} workTime={fruitsThinningWorkTime} />
                );
              }
            }()
          }
          {
            function () {
              if (mating.length !== 0) {
                return (
                  <WorkTimeCell category={Category.MATING} diaryData={mating} workTime={matingWorkTime} />
                );
              }
            }()
          }
          {
            function () {
              if (harvest.length !== 0) {
                return (
                  <WorkTimeCell category={Category.HARVEST} diaryData={harvest} workTime={harvestWorkTime} />
                );
              }
            }()
          }
          {
            function () {
              if (others.length !== 0) {
                return (
                  <WorkTimeCell category={Category.OTHERS} diaryData={others} workTime={othersWorkTime} />
                );
              }
            }()
          }
        </View>

        {/* 円グラフ表示 */}
        <WorkTimeCharts />
      </ScrollView>
      <DiaryDetail />
    </SafeAreaView>
  );
};

export default DiaryReport;